import type { AuthManager, VesperSdk } from '@dicetechnology/vesper-sdk-web';
import { Environment, VesperSdkBuilder } from '@dicetechnology/vesper-sdk-web';

import { refreshTokens } from '@core/uefatvClient/domain';
import { getNewToken } from '@core/uefatvClient/domain.new';
import { getStoredTokens } from '@core/uefatvClient/repository';
import { uefaTvApiKey, uefaTvRealm, environment } from '@utilities/WindowContext';

class MyAuthManager implements AuthManager {
  public async getAuthToken(): Promise<string> {
    const token = (await getNewToken()).authorisationToken;
    return token;
  }

  public async getRefreshToken(): Promise<string> {
    const token = (await getStoredTokens()).refreshToken;
    return token;
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  public async refreshAuthToken(authToken: string): Promise<string> {
    const token = (await refreshTokens()).authorisationToken;
    return token;
  }
}

const authManager = new MyAuthManager();

const sdkBuilder = new VesperSdkBuilder({
  apiConfig: {
    apiKey: uefaTvApiKey,
    environment: environment === 'prd' ? Environment.PROD : Environment.STAGING,
    realm: uefaTvRealm,
  },
  authManager,
});
const sdk: VesperSdk = sdkBuilder.build();

export default sdk;
